import { writable } from "svelte/store";
import type {
	UserData,
	ProfileData,
	StoreData,
	StoreMinData,
} from "@hitit/api";
import { localStore } from "@hitit/utils";
import { t } from "./localization";

export const storeId = localStore("storeId");
export const user = writable<UserData | undefined>(undefined);
export const profile = writable<ProfileData | undefined>(undefined);
export const store = writable<StoreData | undefined>(undefined);
export const storeList = writable<Array<StoreMinData> | undefined>(undefined);